import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/dungarpur.jpg";
import Newsletter from "../../shared/Newsletter";
import { Helmet } from "react-helmet";

const Dungarpur = () => {
  return (
    <>
    <Helmet>
  <title>Dungarpur: Unraveling Cultural Heritage Amidst Royal Legacies & Scenic Marvels</title>

  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />

  <meta name="description" content="Discover Dungarpur, Rajasthan, where rich history and vibrant culture intertwine with royal legacies and scenic marvels. Unravel the tales of Maharawal Veer Singh and explore architectural wonders like Juna Mahal, Udai Bilas Palace, and Gaib Sagar Lake. Immerse yourself in the colorful tapestry of Baneshwar Fair, witness the enigmatic Urs-Galiyakot, and delve into the serenity of Dungarpur Museum and Baneshwar Temple. Uncover the historic Deo Somnath Temple, the vibrant Bar Bij Fair, and the spiritual haven of Poonjpur. Experience Dungarpur, where cultural heritage paints a breathtaking landscape." />

  <meta name="keywords" content="Dungarpur, Rajasthan, Maharawal Veer Singh, Bhil heritage, Juna Mahal, Udai Bilas Palace, Gaib Sagar Lake, Baneshwar Fair, Urs-Galiyakot, Dungarpur Museum, Baneshwar Temple, Deo Somnath Temple, Bar Bij Fair, Poonjpur, scenic marvels, royal legacies, cultural heritage, colorful fairs, architecture, spiritual havens" />

  <meta name="author" content="The Rustic Paths" />

  <meta property="og:title" content="Dungarpur: Unraveling Cultural Heritage Amidst Royal Legacies & Scenic Marvels" />
  <meta property="og:description" content="Discover Dungarpur, Rajasthan, where rich history and vibrant culture intertwine with royal legacies and scenic marvels... (trimmed for brevity)" />
  <meta property="og:image" content={tour1} />

</Helmet>

      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">
          Dungarpur
        </h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Baneshwar Fair</li>
                      <li>Dungarpur Museum</li>
                      <li>Gaib Sagar Lake</li>
                      <li>Juna Mahal</li>
                      <li>Udai Bilas Palace</li>
                      <li>Urs- Galiyakot</li>
                      <li>Baneshwar Temple</li>
                      <li>Baroda (Dungarpur)</li>
                      <li>Bhuvaneshwar Temple</li>
                      <li>Deo Somnath</li>
                      <li>Galiyakot</li>
                      <li>Poonjpur</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Dungarpur
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    It is believed that during the reign of Maharawal Veer Singh
                    Dev, the sixth descendant of Sawant Singh of Mewar, the area
                    of the present Dungarpur was under a powerful Bhil tribal
                    chief, Dungaria. Dungaria aspired to marry the daughter of a
                    wealthy Mahajan name Sala Shah. Sala Shah fixed a distant
                    date for the wedding and, in the meantime, conspired with
                    Veer Singh to assassinate the whole marriage party including
                    Dungaria while they were intoxicated.
                  </p>
                  <p>
                    After the assassination, Rawal Veer Singh took over the
                    possession of the entire area and founded the town of
                    Dungarpur. The name Dungarpur was given to the new town as
                    Rawal Veer Singh had promised the two widows of Dungaria
                    that the new name of the town would be after the name of
                    Dungaria. He also erected a monument in the honor of
                    Dungaria. He further announced that in future, at the time
                    of taking over of the new ruler, a descendant of Dungaria
                    would put the 'Tilak' on the forehead of the ruler from the
                    blood drawn from his finger.
                  </p>

                  <p>
                    Dungarpur is famous for its unique style of architecture as
                    seen in its palaces and noble residences. These royal
                    residences are decked by 'jharokhas' made up of stone in a
                    unique style typical of the area, developed during the reign
                    of Maharawal Shiv Singh (1730-1785 A.D.) The district's gold
                    and silver smiths are renowned for lacquer painted toys and
                    picture framing. The city of Dungarpur has withstood the
                    rise and fall of many empires. Not only Tribal chiefs,
                    Rajput kings, Mongol invaders, Mughals but even Marathas
                    ruled over Dungarpur. The architecture of the city clearly
                    indicates the variation of cultures the town has witnessed.
                    Due to these variations, the historical monuments of the
                    city are worth visiting as all of them are truly unique to
                    the visitors. The major places worth visiting in Dungarpur
                    are Baneshwar Fair, Dungarpur Museum, Gaib Sagar Lake, Juna
                    Mahal, Udai Bilas Palace and Urs-Galiyakot.
                  </p>
                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Baneshwar Fair
                  </h2>

                  <p>
                    This name Baneshwar meaning delta was taken from the
                    venerated Shivlinga kept in the Mahadev temple at Dungarpur.
                    Every year this fair is organized at the place where the
                    rivers Som and Mahi form a delta and the time of the fair is
                    from Magh Shukla Ekadashi to Magh Shukla Purnima every year.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Dungarpur Museum
                  </h2>
                  <p>
                    This is a newly constructed museum and is officially known
                    as Rajmata Devendra Kunwar State Museum and Cultural Centre,
                    Dungarpur. It was opened for the public in the year 1988.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Gaib Sagar Lake
                  </h2>
                  <p>
                    The famous Gaib Sagar Lake is situated amidst the
                    picturesque surroundings at Dungarpur. It is a bird's
                    paradise and has beautiful plantation on its banks.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Juna Mahal
                  </h2>
                  <p>
                    The 13th century seven storeyed building looks a lot like a
                    citadel with stonewalls, towers, narrow entrances and
                    hallways to retard the advancing of the enemy. The marvelous
                    interiors overstated with beautiful frescoes, miniature
                    paintings, glass and mirror work. This building is surely
                    worth a visit on your trip to the city of Dungarpur.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Udai Bilas Palace
                  </h2>
                  <p>
                    This palace was constructed as a home or the royal family
                    and was named after Mahrawal Udai Singh II. The building has
                    excellent work of Rajput architecture with sculpted pillars
                    and panels, balconies and spectacular arches.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Urs- Galiyakot
                  </h2>
                  <p>
                    A small village in Dungarpur district, Galiyakot holds
                    special significance for the sect of Ismaili Shia Muslims
                    who gather there for ziyarat at the memorial of Sayyed
                    Fakhruddin.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Baneshwar Temple
                  </h2>
                  <p>
                    This temple is located at the place where the rivers of Som
                    and Mahi for a delta. This temple has three Shivlings. The
                    Vishnu temple is located near this temple and is believed to
                    be built on the spot where Mavji, an incarnation of Lord
                    Krishna, meditated. A temple of Lord Brahma is also located
                    nearby which is the venue of an annual fair.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Baroda (Dungarpur)
                  </h2>
                  <p>
                    It was initially the capital of Vagad and is famous for the
                    old Shiv Temple made up of white stone and an ancient Jain
                    temple that has the images of all 24 tirthankaras carved a
                    black wall.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Bhuvaneshwar Temple
                  </h2>
                  <p>
                    A colorful fair is held every year five days after holi at
                    the temple of Lord Shiv situated here. Gair dance of the
                    Bhil tribe is the major attraction of the fair.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Deo Somnath
                  </h2>
                  <p>
                    Deo Somnath is an ancient temple of Lord Shiv made up of
                    white stone that was constructed in the 12th century. The
                    temple has an exemplary architecture and symbolizes the art
                    of the ancient times.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Galiyakot
                  </h2>
                  <p>
                    The village of Galiyakot is famous for the shrine of Sayyed
                    Fakhruddin and is visited by thousands of devotees every
                    year. The village also has Jain temples that are worth
                    seeing.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Poonjpur
                  </h2>
                  <p>
                    Poonjpur is a temple dedicated to Mavji who was the
                    incarnation of Lord Krishna and houses the manuscript of 3
                    books called Chopra. Mavji himself wrote Chopra. The temple
                    also has an idol of Nishkalank taking a ride on a horse.
                  </p>


                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Fairs and Festivals of Dungarpur
                  </h2>
                  <p>
                    On the full moon day in the month of February, thousands of
                    devotees from Bhil tribe gather at the convergence of river
                    Mahi and Som and take a holy dip. It is an occasion when
                    people worship, sing and dance. Magic shows and acrobatic
                    displays add interest to the celebrations during Baneshwar
                    fair. Another important celebration of Dungarpur is Bar Bij
                    Fair held every year a month after Diwali. On the fifth day
                    after holi, tribals have a fair where they perform dances
                    and display their traditional artillery.
                  </p>
                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Dungarpur;
